import * as React from 'react'
import classnames from 'classnames'
import { InfoText } from '@/components/atoms'
import { IconButtonGroup, IconButtonGroupProps } from '@/components/common'
import { useTranslation } from 'react-i18next'
import { GranularityType } from '@/hooks'

export type GranularityProps = {
    selectedGranularity?: GranularityType
    onSelect: (granularityType: GranularityType) => void
    label?: string
    className?: string
}

export const Granularity: React.FC<GranularityProps> = ({
    selectedGranularity,
    onSelect,
    label,
    className,
}) => {
    const { t } = useTranslation('translations')

    const buttons: IconButtonGroupProps['buttons'] = [
        {
            id: '1_day',
            label: t('active_management.granularity.options.1_day'),
            size: 'medium',
        },
        {
            id: '1_week',
            label: t('active_management.granularity.options.1_week'),
            size: 'medium',
        },
        {
            id: '1_month',
            label: t('active_management.granularity.options.1_month'),
            size: 'medium',
        },
        {
            id: '2_months',
            label: t('active_management.granularity.options.2_months'),
            size: 'medium',
        },
    ]

    // Use selectedGranularity directly - undefined means no button is selected
    const activeId = selectedGranularity

    const handleButtonClick = (granularityType: string) => {
        onSelect(granularityType as GranularityType)
    }

    return (
        <div className={classnames('flex items-center gap-3', className)}>
            <InfoText
                className="font-medium text-subtle"
                text={label || t('active_management.granularity.label')}
                icon={null}
            />
            <div className="inline-flex">
                <IconButtonGroup
                    buttons={buttons}
                    variant="group"
                    onChange={handleButtonClick}
                    activeId={activeId}
                />
            </div>
        </div>
    )
}
